import React from "react";
import { useCopies } from "shared/hooks/useCopies";
import { warningToast } from "shared/utils/toastNotification";
import UserAgentUtil from "shared/utils/useAgent";
import { FeatureControlCheckArgsType } from "./type";
import { isCurrentPathWhitelisted } from "shared/utils";

export default function useFeatureControlCheckService({
  isMobileSupported = false,
  isTabletSupported = false,
  ...props
}: FeatureControlCheckArgsType) {
  const copies = useCopies();

  const showMobileAppDownloadLinks = React.useMemo(() => {
    if (props.whiteListedRoutesForMobile && isCurrentPathWhitelisted(props.whiteListedRoutesForMobile)) {
      return false;
    }
    return (
      (isMobileSupported === false && UserAgentUtil.isMobileDevice()) ||
      (isTabletSupported === false && UserAgentUtil.isTabletDevice())
    );
  }, [isMobileSupported, isTabletSupported, props.whiteListedRoutesForMobile]);

  const isIEBrowser = React.useMemo(() => UserAgentUtil.isIEBrowser(), []);

  React.useEffect(() => {
    //Ignoring for IE and mobile because For IE we show not supported message, For mobile we show app download links
    if (!isIEBrowser && !showMobileAppDownloadLinks && !UserAgentUtil.isSupportedBrowser()) {
      // for unsupported browser show toast to switch to supported browser
      warningToast(copies.get("switch.to.recommended.browser.msg"), { autoClose: false });
    }
  }, [copies, isIEBrowser, showMobileAppDownloadLinks]);

  return {
    showMobileAppDownloadLinks,
    isIEBrowser
  };
}
